import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../colors.css';
import API_BASE_URL from '../api';

const PersonalityResult = () => {
  const navigate = useNavigate();
  const [personalityType, setPersonalityType] = useState('');
  const [description, setDescription] = useState('');
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Fetch the calculated personality result from the backend
    const fetchPersonalityType = async () => {
      try {
        const token = localStorage.getItem('stack_access_token'); // Get user token
        const response = await fetch(`${API_BASE_URL}/api/personality-test`, {
          method: 'GET',
          headers: {
            'X-Stack-Access-Token': token,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch personality result');
        }

        const data = await response.json();
        setPersonalityType(data.personalityType || 'Unknown Personality');

        // Fetch the description from the database based on the personality type
        const descriptionResponse = await fetch(
          `${API_BASE_URL}/api/personality-description?name=${encodeURIComponent(
            data.personalityType,
          )}`,
          {
            method: 'GET',
            headers: {
              'X-Stack-Access-Token': token,
              'Content-Type': 'application/json',
            },
          },
        );

        if (descriptionResponse.ok) {
          const descData = await descriptionResponse.json();
          setDescription(
            descData.description || 'A unique and fascinating personality!',
          );
        } else {
          setDescription('Description not found.');
        }
      } catch (error) {
        console.error('Error fetching personality result:', error);
        setDescription('Error retrieving personality details.');
      }
    };

    fetchPersonalityType();
  }, []);

  return (
    <div
      className="min-h-screen flex flex-col justify-center items-center relative"
      style={{ backgroundColor: '#0D2329' }}
    >
      {/* Personality Image */}
      <img
        src="/result.png" // Replace with actual image path in public/
        alt="Personality Result"
        className="mb-6 w-35 h-35"
      />
      {/* Result Text */}
      <h1 className="text-3xl font-semibold text-white">You are a</h1>{' '}
      {/* Smaller text */}
      <h2
        className="text-5xl font-bold bg-gradient-to-r from-green-400 to-green-600 text-transparent bg-clip-text mt-2 cursor-pointer"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {personalityType}
      </h2>
      {/* Hover Description */}
      {showTooltip && (
        <div className="absolute top-3/4 bg-white text-black text-sm p-4 rounded-lg shadow-lg max-w-md mt-4">
          {description}
        </div>
      )}
      {/* Continue Button */}
      <button
        onClick={() => navigate('/frontpage')}
        className="mt-6 px-6 py-2 bg-primary text-white text-lg font-semibold rounded-lg shadow-md hover:bg-gray-800 transition duration-300"
      >
        Continue
      </button>
    </div>
  );
};

export default PersonalityResult;
